import { Accordion, Code, List, Text } from "@mantine/core";
import { IconBarcode } from "@tabler/icons-react";

const StationScannerSetup = () => (
  <Accordion variant="separated" w="100%" maw={640}>
    <Accordion.Item value="setup">
      <Accordion.Control icon={<IconBarcode size={18} />}>
        How to set up the USB scanner
      </Accordion.Control>
      <Accordion.Panel>
        <Text size="sm" c="dimmed" mb="sm">
          The scanner works like a keyboard: it types the ticket code and
          presses Enter.
        </Text>
        <List type="ordered" size="sm" spacing={6}>
          <List.Item>
            Use a 2D imager. Laser scanners (red line) can&apos;t read QR codes
            or phone screens.
          </List.Item>
          <List.Item>
            Keep the scanner in USB keyboard (HID) mode with its keyboard layout
            on US English, the factory default. Enter after each scan is the
            usual setting, but Tab or no suffix works too.
          </List.Item>
          <List.Item>
            The laptop&apos;s keyboard layout and Caps Lock do not matter: the
            station reads which keys the scanner pressed.
          </List.Item>
          <List.Item>
            If the station prints badges, launch Chrome with{" "}
            <Code>--kiosk-printing</Code> so no print dialog opens.
          </List.Item>
          <List.Item>
            Turn off sleep, screen blanking and the lock screen on the laptop.
          </List.Item>
        </List>
        <Text size="xs" c="dimmed" mt="sm">
          Quick test: open a text editor and scan a ticket QR. The code should
          appear at once. On a non-US layout some characters look wrong there,
          which the station page handles.
        </Text>
        <Text size="sm" fw={500} mt="md" mb="xs">
          When scans don&apos;t reach the station
        </Text>
        <List size="sm" spacing={6}>
          <List.Item>
            The station window is not in focus. The code is typed into whatever
            window or app is active. Click on the station page and scan again.
          </List.Item>
          <List.Item>
            A print dialog is open. The code is typed into the dialog and the
            scanner&apos;s Enter can press Print or Save. Use{" "}
            <Code>--kiosk-printing</Code> or wait until the dialog closes.
          </List.Item>
        </List>
      </Accordion.Panel>
    </Accordion.Item>
  </Accordion>
);

export default StationScannerSetup;
